const getPowerWordsPoints = (numberOfQuestions, numberOfCorrectAnswers) => {
  const ratio = numberOfCorrectAnswers / numberOfQuestions;
  const options = [
    {
      max: 0.5,
      min: 0,
      points: numberOfCorrectAnswers,
    },
    {
      max: 0.6,
      min: 0.5,
      points: 10,
    },
    {
      max: 0.7,
      min: 0.6,
      points: 15,
    },
    {
      max: 0.8,
      min: 0.7,
      points: 25,
    },
    {
      max: 0.9,
      min: 0.8,
      points: 35,
    },
    {
      max: 1,
      min: 0.9,
      points: 45,
    },
    {
      max: 1,
      min: 1,
      points: 50,
    },
  ];

  if (ratio === 1) {
    return 50;
  }

  if (ratio === 0) {
    return 0;
  }

  const points = options.filter(
    (option) => ratio > option.min && ratio <= option.max,
  )[0]?.points;

  return points;
};

export default getPowerWordsPoints;
